import React from 'react';

import UserProfileSectionHeader from './UserProfileSectionHeader/userProfileSectionHeader';
import UserProfileFormModalContainer from 'buyside/components/container/UserProfileShow/UserProfileFormModalContainer';
import AlertStatic from 'buyside/components/presentation/AlertStatic/alertStatic';

class UserProfileSection extends React.Component {
  constructor() {
    super();
    this.state = { editModalOpen: false };
    this.openEditModal = this.openEditModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openEditModal() {
    this.setState({ editModalOpen: true });
  }

  closeModal() {
    this.setState({
      editModalOpen: false,
      serverError: false
    });
  }

  render() {
    const {
      accreditedInvestorProfile,
      section,
      roleIsAdmin,
      isSumzeroAdmin,
      userProfile,
      icon,
      title,
      sectionEmpty,
      emptyText,
      sectionVisibility,
      component: Component,
      editForm,
      editFormBoxText,
      validationSchema,
      updateUserProfile
    } = this.props;
    const updateSection = ({ userProfile }) => updateUserProfile({ userProfile, section });
    const isOnlyVisibleByAdmin = ['investment_criteria', 'contact'].includes(section);

    return (
      <div>
        <UserProfileSectionHeader
          icon={icon}
          title={title}
          sectionVisibility={sectionVisibility}
          openEditModal={editForm && this.openEditModal}
          roleIsAdmin={roleIsAdmin}
          isOnlyVisibleByAdmin={isOnlyVisibleByAdmin}
        />
        {roleIsAdmin && editForm && (
          <UserProfileFormModalContainer
            isOpen={this.state.editModalOpen}
            closeModal={this.closeModal}
            modalId={`form_${section}`}
            icon={icon}
            title={title}
            alertText={editFormBoxText}
            form={editForm}
            isSumzeroAdmin={isSumzeroAdmin}
            userProfile={userProfile}
            validationSchema={validationSchema}
            update={updateSection}
          />
        )}
        {sectionEmpty && <AlertStatic>{emptyText}</AlertStatic>}
        {!sectionEmpty && (
          <Component
            accreditedInvestorProfile={accreditedInvestorProfile}
            userProfile={userProfile}
          />
        )}
      </div>
    );
  }
}

export default UserProfileSection;
